<template>
  <div class="dorm-tab__left mycursorPointer">
    <div v-on:click="resetDropDown"
      v-if="$route.params.type || $route.params.district" class="dorm-tab__button">
      <span class="button__wrp">
        <span class="dorm-tab__txt">
          See<literal> All</literal>
        </span>
      </span>
    </div>
    <div v-on:click="goPage(tab)"
      class="dorm-tab__button mycursorPointer"
      v-for="tab in tabs" :key="tab.id"
      :class="[{ active : tab.typeID === checkGender }, tab.cat ]">
        <span class="button__wrp">
          <span class="dorm-tab__icon">
            <img :src="tab.icon" alt="" class="icon">
          </span>
          <span class="dorm-tab__txt">
            <span v-html="tab.title">{{tab.title}}</span>
          </span>
        </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DormTabNavCity',
  props: {
    tabs: Array
  },
  data () {
    return {
      currentTab: null
    }
  },
  methods: {
    resetDropDown() {
          //  :to="{ name: 'City', params: { slug: this.$route.params.slug } }" 
      //const route = { name: 'City', params: { slug: this.$route.params.slug, genre:this.$route.params.genre } }
      let sil = this.$route.params.name

     // const route = { name: 'City', params: { page: this.$route.params.slug } }
      const route = { name: 'City', params: { city: this.$route.params.city, id:this.$route.params.id, genre: this.$route.params.genre }}
    
    window.localStorage.setItem('district_name', '')
    window.localStorage.setItem('university_id', '')

    this.$router.push(route)
    },
    goPage(tab) {
      let gender = 'tvshows'
      if(tab.typeID === 2 ) {
        gender = 'movies'
      }
      let route = ''
      if (this.$route.params.district) {
       route = this.$route.params.city + '-' + this.$route.params.district + '-ilcesi--' + gender + '-movies/' 
      } else {
        route = this.$route.params.city + '-ozel-' + gender + '-movies/'
      }

      route = { name: 'CityGender', params: { city:this.$route.params.city, type: 'erkek',gender: gender, genre:this.$route.params.genre, id:this.$route.params.id} }
      this.$router.push(route)

      //this.$router.push('/' + route)
    },
    generateUrl (tab) {
      let route
      if (tab.typeID === 1) {
        if (this.$route.params.district) {
          route = { name: 'CityDistrictGender', params: { type: 'erkek' } }
        } else {
          route = { name: 'CityGender', params: { type: 'erkek' } }
        }
      } else if (tab.typeID === 2) {
        if (this.$route.params.district) {
          route = { name: 'CityDistrictGender', params: { type: 'kiz' } }
        } else {
          route = { name: 'CityGender', params: { type: 'kiz' } }
        }
      }

      
      return route
    }
  },
  computed: {
    checkGender () {
      let typeID = null
      if (this.$route.params.type === 'erkek' || this.$route.params.type === 'ozel-erkek') {
        typeID = 1
      } else if (this.$route.params.type === 'kiz' || this.$route.params.type === 'ozel-kiz') {
        typeID = 2
      }
      return typeID
    }
  }
}
</script>

<style scoped>
  .mycursorPointer { 
    cursor: pointer; 
    }
  .myactive {
      opacity: 1;
      width: 100%

/*       &:after {
        width: 100%;
      } */

    }    
</style>
